import { render, staticRenderFns } from "./add-service.vue?vue&type=template&id=efd56b54&scoped=true"
import script from "./add-service.vue?vue&type=script&lang=js"
export * from "./add-service.vue?vue&type=script&lang=js"
import style0 from "./add-service.vue?vue&type=style&index=0&id=efd56b54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd56b54",
  null
  
)

export default component.exports